import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/ProductListingConfiguration.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/configurations/listings`;
	}
	associateFacetCollection(e, t) {
		return this.api.put(`${n.baseUrl}/${e}/facetCollection`, { facetCollectionConfigurationId: t });
	}
	disassociateFacetCollection(e) {
		return this.api.delete(`${n.baseUrl}/${e}/facetCollection`);
	}
};
export { n as ProductListingConfiguration };

//# sourceMappingURL=ProductListingConfiguration.js.map